<template>
  <div :class="$style.endpointConfig">
    <h3 :class="[$style.endpointConfigHeader, $style.headerBottomMargin]">
      Endpoint Configuration
    </h3>
    <p>
      This section is where you will define the URLs and parameters with which JumpCloud
      will communicate to request this application's user information.
      <strong v-if="showOauthNotice">{{ getMissingStepsNoticeText(OAUTH2) }}</strong>
    </p>

    <!--
      Hide for OAuth until successful auth,
      show for any other auth method
    -->
    <section v-if="showEndpointConfigSection">
      <ScimSpCredentialsForm
        v-if="isOAuth2"
        ref="form"
        :disableActionButton="true"
        :hideTokenField="true"
        :showCancelButton="false"
        :showCtaButton="false"
        :showVanityUrl="true"
        :vanityUrl="vanityUrl"
      />

      <h3 :class="[$style.headerWithDivision, $style.headerBottomMargin]">
        List users
      </h3>
      <p>
        Specify the URL for the API endpoint that will return all the users in this application.
      </p>

      <ListUsersEndpointConfig />
    </section>
  </div>
</template>

<script>
import { authenticationMethods } from 'client/util/Constants/ApplicationConstants';
import { getMissingStepsNoticeText } from 'client/applications/utils/ApplicationUtils';
import IdentityManagementMixin from 'client/applications/mixins/IdentityManagementMixin';
import ListUsersEndpointConfig from 'client/applications/scim/customConnector/ListUsersEndpointConfig.vue';
import ScimSpCredentialsForm from 'client/applications/scim/ScimSpCredentialsForm.vue';

export default {
  name: 'EndpointConfigurationSection',
  components: {
    ListUsersEndpointConfig,
    ScimSpCredentialsForm,
  },
  mixins: [IdentityManagementMixin],
  inject: ['$validator'],

  data() {
    const { OAUTH2 } = authenticationMethods;
    return {
      OAUTH2,
      getMissingStepsNoticeText,
    };
  },

  computed: {
    showEndpointConfigSection() {
      return this.isOAuth2 ? this.isIdmOauthConfigured || this.isScimActive : true;
    },

    showOauthNotice() {
      return this.isOAuth2 && !this.isScimActive && !this.isIdmOauthConfigured;
    },
  },
};
</script>

<style module>
@value (jcBrand, jcGrey200, jcGrey800) from '~css/brand-colors.css';

.endpointConfigHeader {
  color: jcGrey800;
  font-weight: 600;
}

.headerWithDivision {
  border-bottom: 2px solid jcGrey200;
  color: jcGrey600;
  font-size: 1.2rem;
}

.headerBottomMargin {
  margin-bottom: 0.2rem;
}

.methodAndUrl {
  column-gap: 1rem;
  display: flex;
}

.propertyHeader {
  color: jcBrand;
}

.urlField {
  flex: 0 1 auto;
}

.verticalMargin {
  margin: 2rem 0;
}

.methodContainer {
  flex: 1 3 auto;
}
</style>
